import React, { Component } from "react";
import {
  View,
  ScrollView,
  TouchableOpacity,
  Image,
  StyleSheet,
  TouchableWithoutFeedback,
  Platform,
  ImageBackground,
  KeyboardAvoidingView,
  Keyboard,
} from "react-native";
import {
  Button,
  TextInput,
  Checkbox,
  RadioButton,
  Snackbar,
  Surface,
  TouchableRipple,
} from "react-native-paper";
// import { Dropdown } from "react-native-material-dropdown";
// import { withNavigation } from 'react-navigation';
// import BackHandlerAndroid from './../AndroidBackHandler';
import { connect } from "react-redux";
// import Icon from "react-native-vector-icons/dist/Ionicons";
// import Icons from 'react-native-vector-icons/FontAwesome';
// import {isIos,deviceWidth, deviceHeight,  imagePicker, getProfilePic}  from './../Utils';
// import PhotoUpload from 'react-native-photo-upload';
import {
  updateProfile,
  clearUpdateProfileData,
   dispatchClearHomeInfo,getHomeInfo,
  getUpdateProfile,
  clearGetUpdateProfile,
  uploadProfilePic,
  clearUploadProfileData,
} from "./../../store/actions";
// import {resetAll} from './../../navigators/navigationService';
// import Toast, { DURATION } from 'react-native-easy-toast';
// import Icon from 'react-native-vector-icons/dist/Ionicons';
// const isIos = Platform.OS === "ios";
// import Colors from '../Colors';
// import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
// import LinearGradientComponent from './../HeaderBackgroundComponent';
// import StylesColors from './../Colors';
import AsyncStorage from "@react-native-community/async-storage";
// import OfflineHandler from './../OfflineHandler';
import { Text, Styles } from "./../../components/UI-Components";
import CameraAlt from "@material-ui/icons/CameraAlt";
import Toaster from "./../../components/snackBar_toaster";
import Header from "./../../components/Header";

// import AdsScreen from './../Ads';

class EditProfile extends Component {
  constructor(props) {
    super(props);
    const { userDetails ={} } = this.props;
    this.state = {
      visible: false,
      snackbarMsg: "",
        firstName: userDetails.first_name || '',
        lastName: userDetails.last_name || '',
        email: userDetails.email || '',
        gender: userDetails.gender || '',
        city: userDetails.city || '',
        address: userDetails.address || '',
   

      checked: false,
    };
  }

  //   static navigationOptions = ({ navigation }) => {
  //     return {
  //       headerTitle: "EDIT PROFILE",
  //       headerBackground:
  //       ( <LinearGradientComponent />),
  //       headerStyle: {
  //         color:StylesColors.headerTextColor,
  //         fontWeight:StylesColors.headerTextFontWeight,
  //         elevation: 0,
  //         shadowOpacity: 0,
  //         borderBottomWidth: 0,
  //         backgroundColor: Styles.white
  //     },
  //     headerTintColor:StylesColors.headerTintColor,
  //       headerTitleStyle: {
  //         color:StylesColors.headerTextColor,
  //         fontWeight:StylesColors.headerTextFontWeight,
  //         alignItems:'center',
  //         alignSelf: 'center',
  //         // width: '80%',
  //         textAlign: 'center',
  //      },
  //     };
  //   };

  async componentDidMount() {
    this.props.getUpdateProfile();
    if (this.props.profilePicUrl) {
      this.setState({
        imageUrl: this.props.profilePicUrl,
      });
    }
  }
  showToaster = (msg) => {
    this.setState({
      visible: true,
      snackbarMsg: msg,
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.updateProfileResponse !== this.props.updateProfileResponse) {
      if (this.props.updateProfileResponse) {
        this.props.dispatchClearHomeInfo();
        // this.showSnackBar('Successfully updated..!!')
        this.props.getUpdateProfile();
        this.showToaster("Successfully updated..!!");
        this.props.getHomeInfo();
         setTimeout(() => {
            this.props.history.push('Home')
         }, 1000);
      }
    }
    if (prevProps.updateProfileError !== this.props.updateProfileError) {
      if (this.props.updateProfileError) {
        const errorMessage =
          this.props.updateProfileErrInfo || "something went wrong...";
        this.showToaster(errorMessage);
      }
    }

    if (prevProps.getProfileResponse !== this.props.getProfileResponse) {
      if (
        this.props.getProfileResponse &&
        Object.keys(this.props.getProfileResponse).length
      ) {
        const {
          first_name,
          last_name,
          email,
          gender,
          city,
          address,
        } = this.props.getProfileResponse;

        this.setState({
          firstName: first_name,
          lastName: last_name,
          email: email,
          gender: gender,
          city: city,
          address: address,
          userProfile: {
            firstName: first_name,
            lastName: last_name,
            email: email,
            gender: gender,
            city: city,
            address: address,
          },
        });
      }
    }

    if (
      prevProps.uploadProfilePicResponse !== this.props.uploadProfilePicResponse
    ) {
      if (this.props.uploadProfilePicResponse) {
        if (this.props.uploadProfilePicResponse.status === "failure") {
          const message =
            this.props.uploadProfilePicResponse.message ||
            "upload failed, please try again...";
          this.setState({
            isImageUpdated: false,
          });
          this.showToaster(message);
          // AsyncStorage.removeItem('profilePic');
        } else {
          //   this.props.getHomeInfo();
          this.refs.toast.show("Successfully updated", 2000);
          setTimeout(() => {
            //   this.props.navigation.navigate('More');
          }, 2000);
        }
      }
    }

    if (prevProps.profilePicUrl !== this.props.profilePicUrl) {
      if (this.props.profilePicUrl) {
        this.setState({
          imageUrl: this.props.profilePicUrl,
        });
      }
    }
  }

  componentWillUnmount() {
    this.props.clearUpdateProfileData();
    this.props.clearGetUpdateProfile();
  }

  hideSnackBar = () => {
    this.setState({
      visible: false,
      snackbarMsg: "",
    });
  };
  showSnackBar = (message) => {
    this.setState({
      visible: true,
      snackbarMsg: message,
    });
  };

  saveProfilePic = async (uri) => {
    return "false";
    await AsyncStorage.setItem("profilePic", uri);
    const profilePic = await AsyncStorage.getItem("profilePic");
    return profilePic;
  };

  getProfiePic = async () => {
    const profilePic = await AsyncStorage.getItem("profilePic");
    return profilePic;
  };

  isTouched = (obj1, obj2) => {
    const { userDetails } = this.props;
    const {
      first_name = "",
      last_name = "",
      email = "",
      gender = "",
      city = "",
      address = "",
    } = userDetails || {};
    const userInfo = {
      first_name,
      last_name,
      email,
      gender,
      city,
      address,
    };

    const compareObj = obj2 ? obj2 : userInfo;

    if (Object.keys(compareObj).length === Object.keys(obj1).length) {
      let isTouched;
      for (let key in compareObj) {
        for (let key1 in obj1) {
          if (key === key1) {
            if (compareObj[key] !== obj1[key1]) {
              return (isTouched = true);
            }
          }
        }
        if (isTouched) return true;
      }
      return isTouched;
    } else {
      return false;
    }
  };

  uploadProfilePicture = () => {
    const { isImageUpdated, imageUrl } = this.state;
    // console.log(imageUrl, isImageUpdated);
    if (isImageUpdated) this.props.uploadProfilePic(imageUrl);
  };

  updateUserProfileWithProfilePic = () => {
    //   Keyboard.dismiss();
    const userUpdatedDetails = {
      first_name: this.state.firstName,
      last_name: this.state.lastName,
      email: this.state.email,
      city: this.state.city,
      address: this.state.address,
      gender: this.state.gender,
    };
    const isEdited = this.isTouched(userUpdatedDetails, this.state.userProfile);
    if (!isEdited && !this.state.isImageUpdated) {
      return this.showToaster("You have no changes to update.");
    }
    if (this.state.isImageUpdated) {
      this.uploadProfilePicture();
    }
    if (isEdited) {
      this.props.updateProfile(userUpdatedDetails);
    }
  };

  uploadProfilePic = (e) => {
    e.preventDefault();
    // console.log(e.target.files);  
    const imageName = e.target.files[0];
    // console.log(fileName)
    this.setState(
      {
        imageUrl: imageName,
      },
      () => this.props.uploadProfilePic(this.state.imageUrl)
    );
  };

  render() {
    const { checked } = this.state;
    const { userDetails } = this.props;

    return (
      <>
        <Header
          title="Edit Profile"
          // headerRight
          // headerRightClick={() => alert()}
        />
        <div className='main-component'>

        
        <TouchableWithoutFeedback

        >
          <View
            style={{ flex: 1, backgroundColor: Styles.white }}
          >
        
            <ScrollView
              style={styles.mainContainer}
              keyboardShouldPersistTaps={"handled"}
            >
              <Surface
                style={{
                  paddingHorizontal: 20,
                  paddingVertical: 10,
                  marginBottom: 40,
                  backgroundColor: "#fff",
                  marginTop: 5,
                  elevation: 9,

                  //  elevation: 1,
                  borderRadius: 10,
                  borderColor: "#cfcfcf",
                }}
              >
                {/* <BackHandlerAndroid goBack={true} /> */}

                <View style={{ flex: 1, alignItems: "center" }}>
                  {/* <PhotoUpload
   onPhotoSelect={avatar => {
     if (avatar) {
       console.log('Image base64 string: ', avatar)
     }
   }}
 >
   <Image
     style={{
       paddingVertical: 30,
       width: 100,
       height: 100,
       borderRadius: 50
     }}
     resizeMode='cover'
     source={{
       uri: 'https://www.sparklabs.com/forum/styles/comboot/theme/images/default_avatar.jpg'
     }}
   />
 </PhotoUpload> */}

                  {
                    //   userDetails && Object.keys(userDetails).length
                    //   ?
                    //       (

                    <View
                      style={{
                        flex: 1,
                        justifyContent: "center",
                        // marginBottom: 10,
                      }}
                    >
                      {
                        // (userDetails && userDetails.profile_pic) || this.state.imageUrl ?
                        <View
                          style={[
                            styles.circle,
                            { backgroundColor: "#fff", borderColor: "#000" },
                          ]}
                        >
                          <TouchableOpacity
                            onPress={() => {
                           
                            }}
                          >
                            <Image
                              source={{ uri: this.state.imageUrl }}
                              style={{
                                width: 85,
                                height: 85,
                                borderRadius: 50,
                              }}
                            />
                            <View
                              style={{
                                position: "absolute",
                                right: -2,
                                bottom: 8,
                                backgroundColor: "#fff",
                                borderRadius: 20,
                              }}
                            >
                              <form enctype="multipart/form-data">

                              <input
                                type="file"
                                id="validatedCustomFile2"
                                name="imageUrl"
                                style={{ visibility: "hidden", width: 10 }}
                                onChange={this.uploadProfilePic}
                                />
                              <label htmlFor="validatedCustomFile2">
                                <CameraAlt
                                
                                />
                              </label>
                             
                              </form>
                            </View>
                          </TouchableOpacity>
                        </View>
                     
                      }
                    </View>

                  
                  }
                </View>
                <View>
                  <View style={{ marginTop: 30 }}>
                    <TextInput
                      label="First Name"
                      style={styles.inputText}
                      theme={{ colors: { primary: "#A4A4A4" } }}
                      mode="outlined"
                      value={this.state.firstName}
                      onChangeText={(firstName) => this.setState({ firstName })}
                    />
                  </View>

                  <TextInput
                    label="Last Name"
                    style={styles.inputText}
                    mode="outlined"
                    theme={{ colors: { primary: "#A4A4A4" } }}
                    value={this.state.lastName}
                    onChangeText={(lastName) => this.setState({ lastName })}
                  />
                  <TextInput
                    label="E-mail"
                    style={styles.inputText}
                    mode="outlined"
                    theme={{ colors: { primary: "#A4A4A4" } }}
                    value={this.state.email}
                    onChangeText={(email) => this.setState({ email })}
                    editable={!this.props.emailStatus ? true : false}
                  />
                
                  <TextInput
                    label="Address"
                    style={styles.inputText}
                    mode="outlined"
                    theme={{ colors: { primary: "#A4A4A4" } }}
                    value={this.state.address}
                    onChangeText={(address) => this.setState({ address })}
                  />

                  <TextInput
                    label="City"
                    style={styles.inputText}
                    mode="outlined"
                    theme={{ colors: { primary: "#A4A4A4" } }}
                    value={this.state.city}
                    onChangeText={(city) => this.setState({ city })}
                  />
                </View>
        
                <View
                  style={{
                    marginTop: 20,
                    marginBottom: 10,
                    paddingBottom: 20,
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    mode="contained"
                    style={{
                      width: "50%",
                      borderRadius: 20,
                      backgroundColor: Styles.primaryColor,
                    }}
                    // onPress={() => this.props.navigation.navigate('Profile')}
                    disabled={
                      this.props.updateProfileLoading ||
                      this.props.uploadProfilePicLoading
                        ? true
                        : false
                    }
                    onPress={this.updateUserProfileWithProfilePic}
                    uppercase={false}
                  >
                    SUBMIT
                  </Button>
                </View>
              </Surface>
            </ScrollView>

            <Toaster
              show={this.state.visible}
              message={this.state.snackbarMsg}
            />
          </View>
        </TouchableWithoutFeedback>
        </div>
      </>
    );
  }
}

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    paddingVertical: 15,
    paddingHorizontal: 30,
    // backgroundColor: "#fff",
    // paddingBottom:40
    // marginBottom:30
  },
  inputText: {
    backgroundColor: "#fff",
    marginVertical: 8,
  },
  circle: {
    // position:'absolute',
    borderRadius: 50,
    height: 80,
    width: 80,
    borderWidth: 4,
    marginTop: 50,
    justifyContent: "center",
    alignItems: "center",
    marginRight: "18%",
    // marginBottom:40,
    // borderColor:'#f4511e',
    // backgroundColor:'#f4511e',
    borderColor: Styles.primaryColor,
    backgroundColor: Styles.primaryColor,
    ...Platform.select({
      android: {
        paddingBottom: 10,
      },
    }),
  },
  inputBox: {
    width: "100%",
    backgroundColor: "transparent",
    marginTop: 0,
    paddingLeft: 10,
    fontSize: 12,
    // paddingRight:20,
    // marginRight:20
  },
  searchSection: {
    paddingHorizontal: 10,
    paddingRight: 20,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 30,
    marginBottom: 1,
    paddingLeft: 10,
  },
  searchIcon: {
    // paddingHorizontal: 20,
    color: "rgba(0,0,0,0.6)",
    position: "absolute",
    left: 2,
    bottom: 15,
    // marginLeft:25,
    // paddingLeft:40
  },
});

const mapStateToProps = (state) => ({
  userDetails:
    state.homeData && state.homeData.userDetails && state.homeData.userDetails,
  profilePicUrl:
    state.homeData &&
    state.homeData.userDetails &&
    state.homeData.userDetails.profile_pic,
  updateProfileLoading:
    state.updateProfile &&
    state.updateProfile.loading &&
    state.updateProfile.loading,
  updateProfileError:
    state.updateProfile &&
    state.updateProfile.error &&
    state.updateProfile.error,
  updateProfileErrInfo:
    state.updateProfile &&
    state.updateProfile.errorInfo &&
    state.updateProfile.errorInfo.data &&
    state.updateProfile.errorInfo.data.message,
  updateProfileResponse:
    state.updateProfile &&
    state.updateProfile.response &&
    state.updateProfile.response,
  emailStatus:
    state.homeData &&
    state.homeData.userDetails &&
    state.homeData.userDetails.email_status,
  getProfileLoading: state.getUpdateProfile && state.getUpdateProfile.loading,
  getProfileErrorInfo:
    state.getUpdateProfile && state.getUpdateProfile.errorInfo,
  getProfileError: state.getUpdateProfile && state.getUpdateProfile.Error,
  getProfileResponse:
    state.getUpdateProfile &&
    state.getUpdateProfile.response &&
    state.getUpdateProfile.response.user_profile,
  uploadProfilePicLoading:
    state.uploadProfilePic && state.uploadProfilePic.loading,
  uploadProfilePicError: state.uploadProfilePic && state.uploadProfilePic.error,
  uploadProfilePicResponse:
    state.uploadProfilePic && state.uploadProfilePic.response,
});

export default connect(mapStateToProps, {
  updateProfile,
  clearUpdateProfileData,
   dispatchClearHomeInfo,getHomeInfo,
  getUpdateProfile,
  clearGetUpdateProfile,
  uploadProfilePic,
  clearUploadProfileData,
})(EditProfile);
